<template>
    <div class="InfoBanner bg--grey-light">
        <div class="InfoBanner__container container">
            <header>
                <figure class="InfoBanner__icon">
                    <BaseIcon
                        icon="info"
                    />
                </figure>
                <BaseHeading
                    :heading="heading"
                    tag="h4"
                    classes="noline"
                />
            </header>

            <BaseText
                :text="text"
            />

            <BaseButton
                modifier="squared"
                tag="a"
                align="right"
                :href="url"
            >
                <BaseIcon
                    icon="arrow-left"
                />
            </BaseButton>
        </div>
    </div>
</template>
<script>
export default {
    name: 'InfoBanner',
    props: {
        text: {
            type: String,
            default: null
        },
        heading: {
            type: String,
            default: null
        },
        url: {
            type: String,
            default: null
        },
        classes: {
            type: String,
            default: null
        },
    }
}
</script>
<style lang="scss" scoped>
    .InfoBanner__container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        padding: getSpacing('medium');

        @include media-query(desk) {
            padding-top: getSpacing('large');
            padding-bottom: getSpacing('large');
            flex-direction: row;

            header {
                display: flex;
                align-items: center;
                width: 365px;
            }
        }
    }

    .BaseHeading {
        line-height: 0.9;

        @include media-query(portable) {
            text-align: center;
        }
    }

    .InfoBanner__icon {
        display: flex;
        margin: auto;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        background-color: getColour('blue', 'light');
        border-radius: 50%;

        @include media-query(portable) {
            margin-bottom: getSpacing('small');
            width: 40px;
            height: 40px;
        }

        @include media-query(desk) {
            margin-right: getSpacing('medium');
            width: 60px;
            height: 60px;
        }

        .BaseIcon {
            color: getColor('yellow');
            font-size: 1.5rem;
            position: relative;
            left: -1px;
        }
    }

    .BaseButton {
        transform: rotate(180deg);
        flex-shrink: 0;
    }

    .BaseText {
        @include media-query(portable) {
            text-align: center;
            padding-top: getSpacing('small');
            padding-bottom: getSpacing('spacer');
        }

        @include media-query(desk) {
            width: calc(100% - (365px + 42px + 5rem));
            padding: 0 getSpacing('medium');
        }
    }
</style>
